import { accountAddApi } from "../../api/account/accountAddApi"

type PayloadShape = Parameters<typeof accountAddApi>[0]

export async function accountAddService(payload: PayloadShape, token: string) {
	return await accountAddApi(payload, token)
}
